/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Room_SocialInputs */

const en_of_room_social = /** @type {(inputs: Of_Room_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social space`)
};

const id_of_room_social = /** @type {(inputs: Of_Room_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang santai`)
};

/**
* | output |
* | --- |
* | "Social space" |
*
* @param {Of_Room_SocialInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_room_social = /** @type {((inputs?: Of_Room_SocialInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Room_SocialInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_room_social(inputs)
	return en_of_room_social(inputs)
});